import React from 'react';
import { FaBookOpen, FaHandHoldingHeart, FaDonate, FaHandsHelping } from 'react-icons/fa';

const Help = () => {
  const helpData = [
    {
      icon: <FaBookOpen />,
      title: "Educate Others",
      description: "Help educate your community about autism and the real situation of children facing these challenges."
    },
    {
      icon: <FaHandHoldingHeart />,
      title: "Provide Support",
      description: "Lend a helping hand in providing necessities and assisting with domestic skills development."
    },
    {
      icon: <FaDonate />,
      title: "Donate",
      description: "Your financial support helps us provide resources, housing, and education for these children."
    },
    {
      icon: <FaHandsHelping />,
      title: "Volunteer",
      description: "Join us as a volunteer to directly impact the lives of these children in the Maasai community."
    }
  ];

  return (
    <section id="help" className="help">
      <div className="container">
        <h2 className="section-title">How You Can Help</h2>
        <div className="help-container">
          {helpData.map((help, index) => (
            <div key={index} className="help-card">
              <div className="help-icon">
                {help.icon}
              </div>
              <h3>{help.title}</h3>
              <p>{help.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Help;